import { render, staticRenderFns } from "./DsioMods.vue?vue&type=template&id=902e55f2&"
import script from "./DsioMods.vue?vue&type=script&lang=js&"
export * from "./DsioMods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/su_laetis/workspaces/structure-wordpress-php8/httpsdocs/plugins/lae-elementor-diffusio/libs/diffusio/ressources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('902e55f2')) {
      api.createRecord('902e55f2', component.options)
    } else {
      api.reload('902e55f2', component.options)
    }
    module.hot.accept("./DsioMods.vue?vue&type=template&id=902e55f2&", function () {
      api.rerender('902e55f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/DsioMods.vue"
export default component.exports